import { cn } from '../lib/cn.ts'

interface ChipProps {
  label: string
  count?: number
  active?: boolean
  tone?: 'filled' | 'tint'
  onClick: () => void
}

export function Chip({ label, count, active = false, tone = 'filled', onClick }: ChipProps) {
  const activeClass =
    tone === 'filled' ? 'border-brand bg-brand text-white' : 'border-[#bfd4c5] bg-brand-tint text-brand-ink'

  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[13px] transition-colors',
        active ? activeClass : 'border-line bg-surface text-neutral-ink hover:border-[#d8d2c6]',
      )}
    >
      {label}
      {count !== undefined && <span className="tabular opacity-80">{count}</span>}
    </button>
  )
}
